export function fetch(...args: Parameters<Window["fetch"]>): ReturnType<Window["fetch"]> {
    /* eslint-disable-next-line no-restricted-properties --
        This is the only allowed use of the global `fetch` method. All other usage should route through this.
     */
    return self.fetch(...args);
}

export { fetchWithTimeout, type FetchWithTimeoutOptions } from "./fetchWithTimeout";
